type Props = {
  children: React.ReactNode;
  className?: string;
};

export default function AuthPanel({
  children,
  className = 'gap-4 p-4'
}: Props) {
  return (
    <div
      className={`flex w-full flex-col items-center rounded-2xl bg-grey-tile ${className}`}
    >
      {children}
    </div>
  );
}
